const strAuth01 = `강원특별자치도자동차검사정비사업조합

제 1 조 (목적)
이 약관은 강원특별자치도자동차검사정비사업조합(이하 '조합'라 표기합니다)이 제공하는 홈페이지 서비스의 이용조건 및 절차, 기타 필요한 사항을 규정함을 목적으로 합니다.

제 2 조 (약관의 효력과 변경)
1. 이 약관은 이용자에게 공지함으로써 효력을 발생합니다.
2. 이 약관의 내용은 서비스 화면 내에 게시하며 약관의 변경 사항이 있을 경우 조합의 온라인 공지사항을 통해 공지합니다.
3. 조합은 필요하다고 인정되는 경우 이 약관을 개정할 수 있으며 변경된 약관은 제 1 항과 같은 방법으로 효력이 발생합니다.

제 3 조 (약관적용외 준칙)
1. 이 약관은 조합이 제공하는 서비스에 관한 이용규정 및 별도 약관과 함께 적용됩니다.
2. 이 약관에 명시되지 않은 사항이 관계법령에 규정되어 있을 경우에는 그 규정에 따릅니다.

제 4 조 (정의)
이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
1. "이용자"란 "홈페이지"에 접속하여 이 약관에 따라 "홈페이지" 가 제공하는 서비스를 받는 개인회원 및 법인회원을 말합니다.
2. "가입"이란 조합이 제공하는 신청서 양식에 해당 정보를 가입하고, 본 약관에 동의하여 서비스 이용계약을 완료시키는 행위를 말합니다.
3. "회원"이란 "홈페이지"에 개인 및 법인정보를 제공하여 회원등록을 한 이용자로서 "홈페이지 "의 정보를 지속적으로 제공받으며 해당 서비스를 계속적으로 이용할 수 있는 자를 말합니다.
4. "ID"란 회원식별과 회원의 서비스 이용을 위하여 회원이 신청하고 조합이 승인하는 문자 및 숫자의 조합을 말합니다.
5. "비밀번호"란 이용자가 회원ID와 일치하는지를 확인하고 통신상의 자신의 비밀보호를 위하여 이용자 자신이 선정한 문자와 숫자의 조합을 말합니다.
6. "탈퇴"란 회원이 이용계약을 종료 시키는 행위를 말합니다.
7. 본 약관에서 정의하지 않은 용어는 개별서비스에 대한 별도 약관 및 이용규정에서 정의합니다.

제 5 조 (회원자격 및 이용신청)
1. 회원가입은 이용자가 본 약관에 동의하고, 조합에서 요구하는 소정의 가입절차에 응한 후 이루어집니다
2. 조합은 새로운 회원이 가입시 회원 ID를 무료로 제공하며 서비스 이용신청자는 반드시 실명으로 이용신청을 하여야 합니다.
3. 회원가입은 이용자의 이용신청에 대한 조합의 이용 승낙과 이용자의 약관내용에 대한 동의로 성립됩니다.

제 6 조 (회원자격 탈퇴 및 자격상실)
1. 다음 각호의 사유에 해당하는 경우 회원자격을 제한 및 정지시킬 수 있습니다.
가. 타인의 명의를 도용하여 신청하였을 때
나. 이용 계약 신청서의 내용을 허위로 기재하거나 허위서류를 첨부하여 신청하였을 때
다. 사회의 안녕이나 혹은 미풍양속을 저해할 목적으로 신청하였을 때
라. 다른 사람의 조합서비스 이용을 방해하거나 그 정보를 도용하는 등의 행위를 하였을때
마. 조합 사이트를 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우
바. 기타 조합이 정한 이용신청요건이 미비 되었을 때

제 7 조 (서비스의 제공 및 이용)
1. 서비스의 이용은 조합의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴 1일 24시간을 원칙으로 합니다.
2. 조합은 다음 각 호에 해당하는 경우 서비스 제공을 중지할 수 있습니다.
가. 시스템 정비를 위하여 부득이한 경우
나. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지하는 경우
다. 기타 조합이 서비스를 제공할 수 없는 사유가 발생할 경우
3. 조합이 제공하는 서비스는 아래와 같으며, 그 변경될 서비스의 내용을 이용자에게 공지하고 아래에서 정한 서비스를 변경하여 제공 할 수 있습니다.
가. 홈페이지(회원약관)
나. 기타 조합이 자체 개발하거나 다른 조합과의 협력 계약 등을 통해 제공하는 일체의 서비스

제 8 조 (회원정보 사용에 대한 동의)
1. 회원의 개인정보에 대해서는 조합의 개인정보 보호정책이 적용됩니다.
2. 조합의 회원 정보는 다음과 같이 수집, 사용, 관리, 보호됩니다.
가. 개인정보의 수집 : 조합은 귀하의 강원특별자치도자동차검사정비사업조합 서비스 가입 시 귀하가 제공하는 정보, 커뮤니티 활동을 위하여 귀하가 제공하는 정보, 각종 이벤트 참가를 위하여 귀하가 제공하는 정보, 광고나 경품의 취득을 위하여 귀하가 제공하는 정보 등을 통하여 귀하에 관한 정보를 수집합니다.
나. 개인정보의 사용 : 조합은 서비스 제공과 관련해서 수집된 회원의 신상정보를 본인의 승낙 없이 제3자에게 누설, 배포하지 않습니다. 단, 전기통신기본법 등 법률의 규정에 의해 국가기관의 요구가 있는 경우, 범죄에 대한 수사상의 목적이 있거나 정보통신윤리 위원회의 요청이 있는 경우 또는 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우, 귀하가 조합에 제공한 개인정보를 스스로 공개한 경우에는 그러하지 않습니다.
다. 개인정보의 관리 : 귀하는 개인정보의 보호 및 관리를 위하여 홈페이지 회원정보에서 수시로 귀하의 개인정보를 수정/삭제할 수 있습니다.
라. 개인정보의 보호 : 귀하의 개인정보는 오직 귀하만이 열람/수정/삭제 할 수 있으며, 이는 전적으로 귀하의ID와 비밀번호에 의해 관리되고 있습니다. 따라서 타인에게 본인의 ID와 비밀번호를 알려주어서는 아니되며, 작업 종료 시에는 반드시 로그아웃 해 주시고, 웹 브라우저의 창을 닫아 주시기 바랍니다(이는 타인과 컴퓨터를 공유하는 인터넷 카페나 도서관 같은 공공장소에서 컴퓨터를 사용하는 경우에 귀하의 정보의 보호를 위하여 필요한 사항입니다).
마. 기타 : 게시판이나, E-mail,등 온라인상에서 귀하가 자발적으로 제공하는 개인정보는 다른 사람들이 수집하여 사용할 수 있음을 인지하시기 바랍니다. 공개적인 공간에 게재되는 개인정보로 인해 원하지 않는 상황이 발행할 수도 있습니다. 개인정보에 대한 비밀을 유지할 책임은 귀하에게 있으며, 강원협동조합은 개인정보 유출로 인해 발생한 결과에 대하여 어떤 책임도 부담하지 아니합니다.
3. 회원이 조합에 본 약관에 따라 이용신청을 하는 것은 조합이 본 약관에 따라 신청서에 기재된 회원정보를 수집, 이용 및 제공하는 것에 동의하는 것으로 간주됩니다.

제 9 조 (사용자의 정보 보안)
1. 가입 신청자가 조합 서비스 가입 절차를 완료하는 순간부터 귀하는 입력한 정보의 비밀을 유지할 책임이 있으며, 회원의 ID와 비밀번호를 사용하여 발생하는 모든 결과에 대한 책임은 회원본인에게 있습니다.
2. ID 와 비밀번호에 관한 모든 관리의 책임은 회원에게 있으며, 회원의 ID나 비밀번호가 부정하게 사용되었다는 사실을 발견한 경우에는 즉시 조합에 신고하여야 합니다. 신고를 하지 않음으로 인한 모든 책임은 회원 본인에게 있습니다.
3. 이용자는 조합 서비스의 사용 종료 시 마다 정확히 접속을 종료하도록 해야 하며, 정확히 종료하지 아니함으로써 제3자가 귀하에 관한 정보를 이용하게 되는 등의 결과로 인해 발생하는 손해 및 손실에 대하여 조합은 책임을 부담하지 아니합니다.

제 10 조 (정보의 제공 및 광고의 게재)
1. 조합은 서비스를 운용함에 있어 각종 정보를 웹사이트에 게재하는 방법 등으로 회원에게 제공할 수 있습니다.
2. 조합은 서비스의 운영과 관련하여 웹사이트, 전자우편 등에 광고 등을 게재할 수 있습니다.

제 11 조 (조합에 제출된 게시물의 저작권)
1. 귀하가 게시한 게시물의 내용에 대한 권리는 귀하에게 있습니다.
2. 조합은 게시된 내용을 사전 통지 없이 편집, 이동 할 수 있는 권리를 보유하며, 다음의 경우 사전 통지 없이 삭제 할 수 있습니다.
가. 본 서비스 약관에 위배되거나 상용 또는 불법, 음란, 저속하다고 판단되는 게시물을 게시한 경우
나. 다른 회원 또는 제 3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우
다. 공공질서 및 미풍양속에 위반되는 내용인 경우
라. 범죄적 행위에 결부된다고 인정되는 내용일 경우
마. 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
바. 탈퇴자가 게시한 게시물
사. 기타 관계 법령에 위배되는 경우
3. 귀하의 게시물이 타인의 저작권을 침해함으로써 발생하는 민, 형사상의 책임은 전적으로 귀하가 부담하여야 합니다.

제 12 조 (조합의 의무와 책임)
1. 서비스의 소유 및 운영은 조합에 있습니다.
2. 조합은 서비스와 관련하여 득한 회원의 개인정보를 본인의 사전 동의없이 타인에게 누설, 공개 또는 배포할 수 없으며, 서비스관련이외의 상업적인 목적으로 사용할 수 없습니다. 다만 관계법령에 의한 경우 및 수사상의 목적 등의 경우는 예외로 합니다.

제 13 조 (회원의 의무)
1. 회원은 관계법령, 이 약관의 규정, 이용안내 및 주의사항 등 조합이 통지하는 사항을 준수하여야 하며, 기타 조합의 업무에 방해되는 행위를 하여서는 안됩니다.
2. 회원은 조합의 사전 동의없이 서비스를 이용하여 어떠한 영리행위도 할 수 없습니다.
3. 회원은 서비스를 이용하여 얻은 정보를 조합의 사전 동의없이 복사, 복제, 변경, 번역, 출판, 방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없습니다.
4. 회원은 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 안됩니다.
가. 다른 회원의 ID를 부정사용하는 경우
나. 범죄행위를 목적으로 하거나 기타 범죄행위와 관련된 행위
다. 선량한 풍속, 기타 사회질서를 해하는 경우
라. 타인의 명예를 훼손하거나 모욕하는 행위
마. 타인의 지적재산권 등의 권리를 침해하는 행위
바. 해킹행위 또는 컴퓨터바이러스의 유포행위
사. 타인의 의사에 반하여 광고성 정보등 일정한 내용을 전송하는 행위
아. 조합 사이트에 게시된 정보의 변경
자. 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위
차. 기타 관계법령에 위배되는 행위

제 14 조 (회원 정보의 변경)
1. 회원은 회원정보의 변경(주소, E-mail등)이 있을 경우 즉시 조합이 운영하는 웹상 또는 관계자에게 통보 및 수정을 하여야 합니다.
2. 회원의 변경사항에 대한 미통보 및 미수정으로 인한 책임은 전적으로 회원에게 있으며 이는 서비스의 정지 및 해지의 사유가 될 수 있습니다.

제 15 조 (게시물 또는 내용물의 삭제)
조합은 서비스의 게시물 또는 내용물이 규정에 위반되거나 조합의 소정 게시기간을 초과하는 경우 사전 통지나 동의 없이 이를 삭제할 수 있습니다.

제 16 조 (계약해지 및 이용제한)
1. 회원이 이용계약을 해지하고자 하는 때에는 본인이 서비스 또는 전자우편을 통하여 해지하고자 하는 날의 1일전까지 (단, 해지일이 법정공휴일인 경우 공휴일 개시 2일전 까지) 이를 조합에 신청하여야 합니다.
2. 조합은 회원이 이 약관의 내용을 위반하고, 조합 소정의 기간 이내에 이를 해지하지 아니하는 경우 서비스 이용계약을 해지 할 수 있습니다.
3. 조합은 계약내용을 위반하는 회원에 대하여는 사전 동의 없이 이용의 제한 및 정지를 할 수 있습니다.
4. 조합은 회원의 계약내용과 일치하지 않는 사용 및 법령에 위배되는 행위에 관하여 서비스 정지 및 해지에 관한 권리를 갖습니다.

제 17 조 (손해배상)
조합은 무료로 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 동 손해가 조합의 중대한 과실에 의한 경우를 제외하고 이에 대하여 책임을 부담하지 아니합니다.

제 18 조 (면책 조항)
1. 조합은 천재지변 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없을 경우에는 서비스 제공 중지에 관한 책임을 면합니다.
2. 조합은 이용자들의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 면합니다.
3. 조합은 이용자가 서비스를 이용하여 얻은 정보 등으로 인해 입은 손해 등에 대하여는 책임을 면합니다.
4. 조합은 조합이 제공하는 서비스망을 통해 제공하는 정보의 신뢰도나 정확성에 대하여는 책임을 면합니다.
5. 조합은 이용자가 게시 또는 전송한 자료의 내용에 관하여는 책임을 면합니다.

부칙 1.
(시행일) 이 약관은 2021년 11월 1일부터 시행합니다.
`;
const strAuth02 = `개인정보취급정책
1. 총 칙

강원특별자치도자동차검사정비사업조합은 귀하의 개인정보보호를 매우 중요시하며, 『정보통신망이용촉진등에관한법률』상의 정보통신부가 제정한 『개인정보보호지침』을 준수하고 있습니다. 강원특별자치도자동차검사정비사업조합은 개인정보보호방침을 통하여 귀하께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.

2. 개인정보의 수집목적 및 이용목적

강원특별자치도자동차검사정비사업조합은 이용자 확인, 통계&분석을 통한 마케팅 자료로써 귀하의 취향에 맞는 최적의 서비스를 제공하기 위한 목적으로 귀하의 개인정보를 수집, 이용하고 있습니다.
수집하는 개인정보 항목에 따른 구체적인 수집목적 및 이용목적은 다음과 같습니다.

- 성명, 아이디, 비밀번호, 이메일주소: 회원제 서비스 이용에 따른 본인 확인 절차에 이용
- 휴대전화번호, 전화번호 : 고지사항 전달, 불만처리 등을 위한 원활한 의사소통 경로의 확보
- 기타 선택항목 : 개인맞춤 서비스를 제공하기 위한 자료

3. 목적 외 사용 및 제3자에 대한 제공 및 공유

강원특별자치도자동차검사정비사업조합은 귀하의 동의가 있거나 관련법령의 규정에 의한 경우를 제외하고는 어떠한 경우에도 『개인정보의 수집목적 및 이용목적』에서 고지한 범위를 넘어 귀하의 개인정보를 이용하거나 타인 또는 타기업, 기관에 제공하지 않습니다.
귀하의 개인정보를 제공하거나 공유하는 경우에는 사전에 귀하에게 제공받거나 공유하는 자가 누구이며 주된 사업이 무엇인지, 제공 또는 공유되는 개인정보항목이 무엇인지, 개인정보를 제공하거나 공유하는 목적이 무엇인지 등에 대해 개별적으로 전자우편 또는 서면을 통해 고지한 후 이에 대한 동의를 구합니다.
다만, 다음의 경우에는 관련 법령의 규정에 의하여 귀하의 동의 없이 개인정보를 제공하는 것이 가능합니다.
- 서비스제공에 따른 요금정산을 위하여 필요한 경우
- 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 가공하여 제공하는 경우
- 금융실명거래및비밀보장에관한법률, 신용정보의이용및보호에관한법률, 전기통신기본법, 전기통신사업법, 지방세법, 소비자보호법, 한국은행법, 형사소송법 등 법률에 특별한 규정이 있는 경우

4. 개인정보 수집에 대한 동의

강원특별자치도자동차검사정비사업조합은 귀하의 개인정보 수집에 대한 동의를 받고 있습니다. 귀하의 개인정보 수집과 관련하여 강원특별자치도자동차검사정비사업조합의 개인정보보호방침 또는 이용약관의 내용에 대해 「동의」버튼 또는 「취소」버튼을 클릭할 수 있는 절차를 마련하고 있으며, 귀하가 「동의」버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로 봅니다.

5. 개인정보관리책임자

귀하의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 강원특별자치도자동차검사정비사업조합은 개인정보관리책임자를 두고 있습니다. 개인정보와 관련한 문의사항이 있으시면 아래의 개인정보관리책임자에게 연락주시기 바랍니다. 귀하의 문의사항에 신속하고 성실하게 답변해드리겠습니다.

[ 개인정보관리책임자 ]
Tel : 033.761.5200
Fax : 033.763.3110

6. 개인정보의 수집

강원특별자치도자동차검사정비사업조합은 회원가입시 서비스 이용을 위해 필요한 최소한의 개인정보만을 수집합니다.
귀하가 강원특별자치도자동차검사정비사업조합의 서비스를 이용하기 위해서는 조합원 가입신청서에 명시된 내용(성명, 주소, 전화번호, 휴대번호)를 필수적으로 입력하셔야 합니다. 그러나, 기타 선택항목은 이를 입력하지 않더라도 서비스 이용에는 제한이 없습니다.

7. 쿠키에 의한 개인정보 수집

강원특별자치도자동차검사정비사업조합은 귀하의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’를 운용합니다. 쿠키란 강원특별자치도자동차검사정비사업조합의 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다. 강원특별자치도자동차검사정비사업조합은 다음과 같은 목적을 위해 쿠키를 사용합니다.
회원과 비회원의 접속 빈도나 방문 시간 등을 분석하고 이용자의 취향과 관심분야를 파악하여 타겟(target) 마케팅 및 서비스 개편 등의 척도로 활용합니다.
강원특별자치도자동차검사정비사업조합이 진행하는 각종 이벤트에서 귀하의 참여 정도 및 방문 회수를 파악하여 차별적인 응모 기회를 부여하고 개인의 관심 분야에 따라 차별화된 정보를 제공하기 위한 자료로 이용됩니다.
귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
회원님께서 쿠키 설치를 거부하셨을 경우 강원특별자치도자동차검사정비사업조합서비스 제공에 어려움이 있습니다.

8. 개인정보의 열람과 정정

귀하는 언제든지 등록되어 있는 귀하의 개인정보를 열람하거나 정정하실 수 있습니다. 귀하의 개인정보에 대한 열람 또는 정정을 하고자 할 경우에는 개인정보관리책임자에게 서면, 전화 또는 E-mail로 연락하시면 지체없이 조치하겠습니다.
귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록 조치하겠습니다.

9. 동의철회(회원탈퇴)

귀하는 회원가입시 개인정보의 수집/이용 및 제공에 대해 동의하신 내용을 언제든지 철회하실 수 있습니다. 동의철회(회원탈퇴)는 강원특별자치도자동차검사정비사업조합 개인정보관리책임자에게 서면, 전화 또는 E-mail 등으로 연락하시면 지체없이 귀하의 개인정보를 파기하는 등 필요한 조치를 하겠습니다.

10. 개인정보의 보유기간 및 이용기간

강원특별자치도자동차검사정비사업조합은 개인정보의 수집목적 또는 제공받은 목적이 달성된 때에는 귀하의 개인정보를 지체없이 파기합니다.

- 회원가입정보의 경우 : 회원가입을 탈퇴하거나 회원에서 제명된 때
- 설문조사, 이벤트 등의 목적을 위하여 수집한 경우 : 당해 설문조사, 이벤트 등이 종료한 때
- 다만, 수집목적 또는 제공받은 목적이 달성된 경우에도 상법 등 법령의 규정에 의하여 보존할 필요성이 있는 경우에는 귀하의 개인정보를 보유할 수 있습니다.
11. 개인정보침해 관련 상담 및 신고

개인정보침해에 대한 신고.상담이 필요하신 경우에는 한국인터넷진흥원(KISA)내 개인정보침해신고센터로 문의하시기 바랍니다.

[ 개인정보침해신고센터 ]
전화 : 02) 405-5118
URL : http://privacy.kisa.or.kr/

12. 정책 변경에 따른 공지의무

이 개인정보보호방침은 2021년 11월 1일에 제정되었으며 법령과 정책 또는 보안기술의 변경에 따라 내용의 추가, 삭제 및 수정이 있을 시에는 변경되는 개인정보보호정책을 시행하기 최소 10일전에 강원특별자치도자동차검사정비사업조합 홈페이지를 통해 변경이유 및 내용 등을 공지하도록 하겠습니다.
`;

export { strAuth01, strAuth02 };
